import { addQueryParam } from 'shared/utils/add-query-param'

export const buildSearchUrl = (
  query: string,
  communityPath?: string,
  topicPath?: string,
): string => {
  const params = new URLSearchParams()
  addQueryParam(params, 'q', query)
  addQueryParam(params, 'topicPath', topicPath)

  if (!communityPath) {
    throw new Error('communityPath is required to build search URL')
  }

  return `/community/${communityPath}/search?${params.toString()}`
}
